import { useEffect, useState } from "react";
import RequestItem from "./Panels/RequestItem";

const { Box } = require("@mui/system");

const DATA = [{}, {}, {}];
const InvoiceRequests = (props) => {
  const [requests, setRequests] = useState([]);

  useEffect(() => {
    setRequests(DATA);
  }, []);

  return (
    <Box p={3}>
      {requests.map((item, index) => (
        <RequestItem />
      ))}
    </Box>
  );
};

export default InvoiceRequests;
